<template>
  <div>
    <p class="placeholder-glow mb-16">
      <span
        class="placeholder bg-skeleton"
        style="width: 300px; height: 32px"
      ></span>
    </p>
    <p class="placeholder-glow mb-16">
      <span
        class="placeholder bg-skeleton"
        style="width: 100%; height: 96px"
      ></span>
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@include media-breakpoint-up(lg) {
  .placholder:nth-of-type(2) {
    width: 150% !important;
  }
}
</style>
